import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Notes = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-slate-100 dark:from-gray-900 dark:to-gray-800 p-4" data-testid="notes-page">
      <div className="max-w-3xl mx-auto py-8">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="mb-6 text-slate-600 hover:text-slate-900"
          data-testid="notes-back-btn"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Sign In
        </Button>

        <Card className="shadow-2xl">
          <CardHeader className="text-center pb-4">
            <div className="mx-auto w-16 h-16 bg-blue-600 rounded-2xl flex items-center justify-center mb-2">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <CardTitle className="text-2xl sm:text-3xl font-bold">About TaskPriority Prime</CardTitle>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none px-6 sm:px-10 pb-8">
            <p className="text-base text-slate-700 leading-relaxed mb-6">
              I've created this web app to do basic, uncomplicated prioritized daily task lists. Simple ABC organization. You can:
            </p>

            <ul className="space-y-3 text-sm sm:text-base text-slate-700 list-disc pl-5">
              <li>Create tasks for any date; but it automatically defaults to the current day</li>
              <li>Select A, B, or C or you can simply double click in any of the category colored boxes to automatically set that priority when you enter the new task</li>
              <li>At any time you can mark a task as "In Progress", "Waiting", or "Complete" from the dropdown box within each task</li>
              <li>Search for specific Tasks</li>
              <li>Set tasks as "recurring"</li>
              <li>Copy Tasks ("for completing and forwarding")</li>
              <li>Check the box in the task to "complete" it. It can stay where it is, or in Settings change it to "move to bottom" of that list</li>
              <li>And most importantly you can drag and drop inside each category to prioritize those tasks, but you can also drag and drop BETWEEN the three categories for easy assignment or changes to how important a task might be (drag from the six vertical dots to "grab" it)</li>
            </ul>

            <div className="mt-6 space-y-4 text-sm sm:text-base text-slate-700 leading-relaxed">
              <p>
                In Settings (the gear) you can change what happens when a task is completed, Show or Hide the description field, choose to layout the categories side by side or "stacked" (they will probably always be "stacked" when you look at it on your cellphone), choose whether to have the tasks numbered or not, and choose Light or Dark mode. There are also 3 different Themes you can choose from.
              </p>

              <p>
                If a task isn't completed on any day, it is automatically forwarded to the next day for you -- you don't have to do a thing to reset it or have to try to remember.
              </p>

              <p>
                Since you are logging in and out as necessary you should be able to use this on any device (as long as you have some kind of internet access), so you always have access to YOUR same Task List wherever you are working, and can add tasks as you think of them wherever you are.
              </p>

              <p>
                This will hold data for about 30 days. This app is still in "BETA" testing, so if you run across a bug or glitch, let me know. I'm still working to update it as I get time (but haven't had much of that lately).
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Notes;
